import styled from '@emotion/styled';
export const ModalCopyWrapper = styled.div `
  width: 224px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--gray2);
  color: white;
  font-size: 14px;
  border-radius: 6px;
  padding: 14px;
`;
